import { render, staticRenderFns } from "./ns-orders-refund-product-popup.vue?vue&type=template&id=97c37888&"
import script from "./ns-orders-refund-product-popup.vue?vue&type=script&lang=js&"
export * from "./ns-orders-refund-product-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports